import React from "react";
import singpassLogoWhite from "./singpass_logo_white-1.png";

const SingpassCorppassLogin = ({
  isLoading,
  onClick,
  roleLabel = "as Corppass user",
  loadingAriaLabel = "Connecting to Singpass as Corppass user",
  idleAriaLabel = "Log in with Singpass as Corppass user",
}) => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "6px",
      width: "100%",
      fontFamily: '"Poppins", "Inter", "Arial", sans-serif',
    },
    button: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      minHeight: "48px",
      padding: "0 20px",
      border: "none",
      backgroundColor: "#F4333D",
      color: "#FFFFFF",
      boxShadow: "none",
      cursor: "pointer",
      fontFamily: '"Poppins", "Inter", "Arial", sans-serif',
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "1.25",
      transition: "background-color 0.2s ease",
    },
    buttonDisabled: {
      backgroundColor: "#F4333D",
      color: "#FFFFFF",
      opacity: 0.65,
      cursor: "not-allowed",
    },
    innerFlex: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      lineHeight: "16px",
    },
    image: {
      width: "auto",
      height: "16px",
      flexShrink: 0,
      objectFit: "contain",
      marginBottom: "-6px",
    },
    typography: {
      fontFamily: '"Poppins", "Inter", "Arial", sans-serif',
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: 1.4,
      color: "rgba(0, 0, 0, 0.6)",
    },
  };

  return (
    <div style={styles.container}>
      <button
        onClick={onClick}
        disabled={isLoading}
        aria-label={isLoading ? loadingAriaLabel : idleAriaLabel}
        style={{
          ...styles.button,
          ...(isLoading ? styles.buttonDisabled : {}),
        }}
        onMouseEnter={(e) =>
          !isLoading && (e.currentTarget.style.backgroundColor = "#B0262D")
        }
        onMouseLeave={(e) =>
          !isLoading && (e.currentTarget.style.backgroundColor = "#F4333D")
        }
      >
        <div style={styles.innerFlex}>
          {isLoading ? (
            <>
              <div
                style={{
                  width: 18,
                  height: 18,
                  border: "2px solid #fff",
                  borderTopColor: "transparent",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                }}
              />
              Connecting...
            </>
          ) : (
            <>
              Log in with
              <img
                src={singpassLogoWhite}
                alt='Sing pass'
                style={styles.image}
              />
            </>
          )}
        </div>
      </button>

      <p style={styles.typography}>{roleLabel}</p>
    </div>
  );
};

export default SingpassCorppassLogin;
